"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _button = require("@design/ui/button");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function LoginHandoff(_ref) {
  var phase = _ref.phase,
    onRetry = _ref.onRetry;
  if (phase === "error") {
    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "flex flex-col items-center gap-4 text-center",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "text-lg font-semibold text-gray-900",
        children: "Sign-in didn\u2019t complete"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        className: "max-w-xs text-sm text-gray-500",
        children: "Your browser should have opened for sign-in. If it didn\u2019t, or the sign-in timed out, try again."
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
        variant: "outline",
        size: "lg",
        className: "w-full max-w-xs",
        onClick: onRetry,
        children: "Try again"
      })]
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "flex flex-col items-center gap-4 text-center",
    "data-sentry-component": "LoginHandoff",
    "data-sentry-source-file": "LoginHandoff.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "h-9 w-9 animate-spin rounded-full border-[3px] border-gray-300 border-t-muted-foreground"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "text-lg font-semibold text-gray-900",
      children: "Signing you in"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: "max-w-xs text-sm text-gray-500",
      children: "Finish signing in through your browser. We\u2019ll pick things up here automatically once you\u2019re done."
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.Button, {
      variant: "ghost",
      size: "sm",
      onClick: onRetry,
      "data-sentry-element": "Button",
      "data-sentry-source-file": "LoginHandoff.tsx",
      children: "Reopen sign-in"
    })]
  });
}
var _default = exports.default = LoginHandoff;